<template>
  <div @click="handleClick">
    <prism-editor
      ref="editor"
      class="my-editor height-300"
      v-model="code"
      :highlight="highlighter"
      :line-numbers="lineNumbers"
      v-bind="$attrs"
      @blur="change"
    ></prism-editor>
  </div>
</template>

<script>
import { PrismEditor } from "vue-prism-editor"
import "vue-prism-editor/dist/prismeditor.min.css"
import { highlight, languages } from "prismjs/components/prism-core"
import "prismjs/components/prism-clike"
import "prismjs/components/prism-javascript"
import "prismjs/themes/prism-tomorrow.css"
export default {
  props: ["value"],
  components: { PrismEditor },
  data() {
    return {
      lineNumbers: true,
      code: "",
    }
  },
  created() {},
  mounted() {},
  watch: {
    value: {
      handler(val) {
        this.code = val
      },
      immediate: true,
    },
  },
  computed: {},
  methods: {
    highlighter(code) {
      return highlight(code, languages.js) //returns html
    },
    change(val) {
      this.$emit("change", val.target.value)
    },
    handleClick() {
      this.$refs.editor.$el.lastChild.firstChild.focus()
    },
  },
}
</script>

<style scoped>
/* // required class */
.my-editor {
  background: #2d2d2d;
  color: #ccc;

  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

/* // optional */
.prism-editor__textarea:focus {
  outline: none;
}

/* // not required: */
.height-300 {
  height: 300px;
}
</style>
